import React, { useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import { useCountDown } from 'ahooks';
import dynamic from 'next/dynamic';
import Dialog from './Dialog';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import EcoLink from 'eco-design/base/eco-link';
import EcoIconArrowButton from 'eco-design-micro/icons/eco-icon-arrow-button';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import gtm from '@/utils/gtm';

interface Props {
    endTime: number;
}

const Countdown = dynamic(() => import('./Countdown'), {
    ssr: false, // 关键点：关闭服务端渲染
});

const EarlyBird: React.FC<Props> = ({ endTime }) => {
    const { getSystemTime, useRouter } = useGlobal();
    const router = useRouter();
    const { t } = useLang('theProduct.EarlyBird');
    const { locale = 'us' } = getLocal();

    const EU_List = [
        {
            title: t('item1'),
            desc: t('desc1'),
            pc: (() => {
                const img = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1750400777411/EN.png',
                    es: 'https://websiteoss.ecoflow.com/upload/image/1750400777228/ES.png',
                    it: 'https://websiteoss.ecoflow.com/upload/image/1750400776858/IT.png',
                    fr: 'https://websiteoss.ecoflow.com/upload/image/1750400777061/FR.png',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1750400776666/DE.png',
                };
                return img[locale as 'en'] || img['en'];
            })(),
        },
        {
            title: t('item2'),
            desc: t('desc2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749019824638/2.png',
        },
        {
            title: t('item3'),
            desc: t('desc3'),
            pc: (() => {
                const img = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1750400870271/EN.png',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1750400869750/DE.png',
                    fr: 'https://websiteoss.ecoflow.com/upload/image/1750400870445/FR.png',
                    it: 'https://websiteoss.ecoflow.com/upload/image/1750400870642/IT.png',
                    es: 'https://websiteoss.ecoflow.com/upload/image/1750400870118/ES.png',
                };
                return img[locale as 'en'] || img['en'];
            })(),
            linkText: t('link3'),
            link: `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Mag&powerbank-trade-in=true`,
        },
    ];

    const NA_List = [
        {
            title: t('item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1752113166423/1.png',
        },
        {
            title: t('item2'),
            desc: t('desc2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1754270750100/2.png',
            // link: `/${locale}/ecocredits`,
        },
        {
            title: t('item3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1752113166597/3.png',
        },
        {
            title: t('item4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1752113166990/4.png',
        },
    ];

    // 倒计时
    const [, formattedRes] = useCountDown({ targetDate: endTime });

    // 弹窗
    const [open, setOpen] = useState(false);

    let systemTime = getSystemTime();
    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    if (systemTime >= endTime) return null;

    const IS_NA = ['us', 'ca'].includes(locale);
    const list: any = IS_NA ? NA_List : EU_List;

    return (
        <>
            <EcoSpace />
            <div className={`${style.comp} EarlyBird GtmModuleData-section`} data-section-id={'EarlyBird'}>
                <EcoTitle title={t('title')} />
                <Countdown days={formattedRes.days} hours={formattedRes.hours} minutes={formattedRes.minutes} seconds={formattedRes.seconds} />
                <div className="cards">
                    {list.map((i, idx) => (
                        <EcoLink
                            className={`card-item GtmModuleData-btn-href item-${idx + 1}`}
                            href={i.link}
                            key={idx}
                            dataLayer={{
                                __btn_id1: `EarlyBird .item-${idx + 1}`,
                                __btn_id2: i.link,
                                __btn_type: 'text',
                            }}
                        >
                            <img src={i.pc} alt="" />
                            <div className="card-item-info">
                                <div className="card-item-title">{i.title}</div>
                                {i.desc && <div className="card-item-desc">{i.desc}</div>}
                                {i.linkText && (
                                    <EcoLink
                                        className={`card-item-link GtmModuleData-btn-href btn-${idx + 1}`}
                                        href={i.link}
                                        dataLayer={{
                                            __btn_id1: `EarlyBird .btn-${idx + 1}`,
                                            __btn_id2: i.link,
                                            __btn_type: 'text',
                                        }}
                                    >
                                        {i.linkText}
                                        <EcoIconArrowButton />
                                    </EcoLink>
                                )}
                            </div>
                        </EcoLink>
                    ))}
                </div>
                <div
                    className="tc-btn GtmModuleData-btn-text"
                    onClick={() => {
                        setOpen(true);
                        gtm.push({
                            __btn_id1: 'EarlyBird .tc-btn',
                            __btn_id2: t('footer'),
                            __btn_type: 'text',
                        });
                    }}
                >
                    {t('footer')}
                </div>
            </div>

            <Dialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};
export default EarlyBird;
